/**
 * Handle clipboard copy functionality for share buttons
 */
document.addEventListener( 'DOMContentLoaded', () => {
	// Handle clipboard copy
	const clipboardButtons = document.querySelectorAll( '.js-share-clipboard' );

	clipboardButtons.forEach( ( button ) => {
		button.addEventListener( 'click', async ( e ) => {
			e.preventDefault();

			const url = button.getAttribute( 'data-url' );

			if ( ! url ) {
				return;
			}

			try {
				// Try using the modern Clipboard API
				if ( navigator.clipboard && navigator.clipboard.writeText ) {
					await navigator.clipboard.writeText( url );
					showCopyFeedback( button, true );
				} else {
					// Fallback for older browsers
					const textArea = document.createElement( 'textarea' );
					textArea.value = url;
					textArea.style.position = 'fixed';
					textArea.style.left = '-999999px';
					textArea.style.top = '-999999px';
					document.body.appendChild( textArea );
					textArea.focus();
					textArea.select();

					const successful = document.execCommand( 'copy' );
					document.body.removeChild( textArea );

					showCopyFeedback( button, successful );
				}
			} catch ( err ) {
				showCopyFeedback( button, false );
				// eslint-disable-next-line no-console
				console.error( 'Failed to copy URL:', err );
			}
		} );
	} );

	// Handle print functionality
	const printButtons = document.querySelectorAll( '.js-share-print' );

	printButtons.forEach( ( button ) => {
		button.addEventListener( 'click', ( e ) => {
			e.preventDefault();
			window.print();
		} );
	} );
} );

/**
 * Show visual feedback when copying to clipboard
 *
 * @param {HTMLElement} button  - The button that was clicked
 * @param {boolean}     success - Whether the copy was successful
 */
function showCopyFeedback( button, success ) {
	const originalLabel = button.querySelector( '.a11y' );
	const originalText = originalLabel ? originalLabel.textContent : '';

	if ( originalLabel ) {
		originalLabel.textContent = success ? 'Copied!' : 'Failed to copy';
	}

	// Add visual feedback class
	button.classList.add( success ? 'is-copied' : 'is-error' );

	// Reset after 2 seconds
	setTimeout( () => {
		if ( originalLabel ) {
			originalLabel.textContent = originalText;
		}
		button.classList.remove( 'is-copied', 'is-error' );
	}, 2000 );
}
